module.exports = __webpack_public_path__ + "Flag-196.b68db572ab0dca5f06e3690c98e4dafe.svg";